module.exports = __webpack_public_path__ + "media/KZ-AKT.af3da446.ogg";